/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";

import produtosEmUsoService from "../../api/atendimentos/produtosEmUsoService";
import { formataDataExibicao, formataDataHoraExibicao, frequenciasProdutosEmUso, ordenacaoProdutosEmUso, ordensOrdenacaoProdutosEmUso } from "../../common/utils";

class ProdutosEmUsoAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            loadingModal: false,
            error: '',
            historico: [],
            ordenar_por: 'produto',
            ordem: 'asc',
            showModal: false,
            modalTitulo: 'Adicionar Medicamento',
            registroEditando: null,
            produto_id: '',
            produto_nome: '',
            dose: '',
            frequencia_uso: '',
            data_inicio_uso: '',
            data_interrupcao_uso: '',
        };
    }

    componentDidMount() {
        this.carregarHistorico();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.atendimentoId !== this.props.atendimentoId ||
            prevState.ordenar_por !== this.state.ordenar_por ||
            prevState.ordem !== this.state.ordem
        ) {
            this.carregarHistorico();
        }
    }

    getDataHoje = () => {
        return new Date().toISOString().slice(0, 10);
    };

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === 'string' && data.trim()) {
            return data;
        }

        if (data && typeof data === 'object') {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === 'string' && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregarHistorico = () => {
        const { atendimentoId } = this.props;
        const { ordenar_por, ordem } = this.state;

        if (!atendimentoId) {
            this.setState({ historico: [], loading: false, error: '' });
            return;
        }

        this.setState({ loading: true, error: '' });

        produtosEmUsoService.listar(atendimentoId, ordenar_por, ordem)
            .then((response) => {
                this.setState({
                    historico: Array.isArray(response.data?.resultados) ? response.data.resultados : [],
                    loading: false,
                    error: '',
                });
            })
            .catch((error) => {
                console.error('Erro ao carregar histórico de produtos em uso:', error);
                this.setState({
                    loading: false,
                    error: this.getMensagemErro(error, 'Erro ao carregar produtos em uso, tente novamente.'),
                });
            });
    };

    limparFormulario = () => {
        this.setState({
            registroEditando: null,
            produto_id: '',
            produto_nome: '',
            dose: '',
            frequencia_uso: '',
            data_inicio_uso: '',
            data_interrupcao_uso: '',
        });
    };

    abrirModalNovo = () => {
        this.limparFormulario();
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar Medicamento',
            registroEditando: null,
        });
    };

    abrirModalEditar = (registro) => {
        this.setState({
            showModal: true,
            modalTitulo: `Editar Medicamento #${registro.id}`,
            registroEditando: registro,
            produto_id: registro?.produto_id || '',
            produto_nome: registro?.dados_produto?.nome || '',
            dose: registro?.dose || '',
            frequencia_uso: registro?.frequencia_uso || '',
            data_inicio_uso: registro?.data_inicio_uso || '',
            data_interrupcao_uso: registro?.data_interrupcao_uso || '',
        });
    };

    fecharModal = () => {
        if (this.state.loadingModal) return;

        this.setState({ showModal: false }, () => {
            this.limparFormulario();
        });
    };

    onChangeCampo = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    onChangeProduto = (option) => {
        this.setState({
            produto_id: option?.value || '',
            produto_nome: option?.label || '',
        });
    };

    validarFormulario = () => {
        const {
            registroEditando,
            produto_id,
            dose,
            frequencia_uso,
            data_inicio_uso,
            data_interrupcao_uso,
        } = this.state;

        const hoje = this.getDataHoje();

        if (!registroEditando && !produto_id) {
            Swal.fire('Atenção', 'Selecione o produto em uso.', 'warning');
            return false;
        }

        if (!String(dose || '').trim()) {
            Swal.fire('Atenção', 'Informe a dose.', 'warning');
            return false;
        }

        if (!frequencia_uso) {
            Swal.fire('Atenção', 'Selecione a frequência de uso.', 'warning');
            return false;
        }

        if (!data_inicio_uso) {
            Swal.fire('Atenção', 'Informe a data de início de uso.', 'warning');
            return false;
        }

        if (data_inicio_uso > hoje) {
            Swal.fire('Atenção', 'A data de início do medicamento não pode ser futura.', 'warning');
            return false;
        }

        if (data_interrupcao_uso) {
            if (data_interrupcao_uso < data_inicio_uso) {
                Swal.fire('Atenção', 'A data de interrupção não pode ser inferior à data de início.', 'warning');
                return false;
            }

            if (data_interrupcao_uso > hoje) {
                Swal.fire('Atenção', 'A data de interrupção não pode ser superior à data atual.', 'warning');
                return false;
            }
        }

        return true;
    };

    salvarRegistro = () => {
        const { atendimentoId } = this.props;
        const {
            registroEditando,
            produto_id,
            dose,
            frequencia_uso,
            data_inicio_uso,
            data_interrupcao_uso,
        } = this.state;

        if (!this.validarFormulario()) {
            return;
        }

        this.setState({ loadingModal: true });

        const payload = registroEditando ? {
            dose: String(dose || '').trim(),
            frequencia_uso,
            data_interrupcao_uso: data_interrupcao_uso || null,
        } : {
            atendimento_id: atendimentoId,
            produto_id,
            dose: String(dose || '').trim(),
            frequencia_uso,
            data_inicio_uso,
            data_interrupcao_uso: data_interrupcao_uso || null,
        };

        const request = registroEditando
            ? produtosEmUsoService.update(registroEditando.id, payload)
            : produtosEmUsoService.create(payload);

        request
            .then(() => {
                this.setState({ loadingModal: false, showModal: false }, () => {
                    this.limparFormulario();
                    this.carregarHistorico();
                });

                Swal.fire(
                    'Sucesso',
                    registroEditando
                        ? 'Medicamento atualizado com sucesso.'
                        : 'Medicamento cadastrado com sucesso.',
                    'success'
                );
            })
            .catch((error) => {
                console.error('Erro ao salvar produto em uso:', error);
                this.setState({ loadingModal: false });
                Swal.fire('Erro', this.getMensagemErro(error, 'Erro ao salvar produto em uso.'), 'error');
            });
    };

    renderStatus = (registro) => {
        if (registro?.uso_ativo || !registro?.data_interrupcao_uso) {
            return <Badge bg="success">Ativo</Badge>;
        }

        return <Badge bg="secondary">Encerrado</Badge>;
    };

    render() {
        const { podeEditar, atendimentoId } = this.props;
        const {
            loading,
            loadingModal,
            error,
            historico,
            ordenar_por,
            ordem,
            showModal,
            modalTitulo,
            registroEditando,
            produto_id,
            produto_nome,
            dose,
            frequencia_uso,
            data_inicio_uso,
            data_interrupcao_uso,
        } = this.state;

        const loadProdutosDisponiveis = produtosEmUsoService.loadProdutosDisponiveis(atendimentoId);

        return (
            <>
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h6><strong>Medicamentos em Uso</strong></h6>
                            </Col>
                            {podeEditar && (
                                <Col sm={6} xs={6} className="text-end">
                                    <Button type="button" variant="success" className="btn-sm mt-3" onClick={this.abrirModalNovo}>
                                        Adicionar Medicamento
                                    </Button>
                                </Col>
                            )}
                        </Row>

                        <Row className="mb-3">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Ordenar por</Form.Label>
                                    <Form.Select name="ordenar_por" value={ordenar_por} onChange={this.onChangeCampo}>
                                        {Object.entries(ordenacaoProdutosEmUso).map(([valor, label]) => (
                                            <option key={valor} value={valor}>{label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Ordem</Form.Label>
                                    <Form.Select name="ordem" value={ordem} onChange={this.onChangeCampo}>
                                        {Object.entries(ordensOrdenacaoProdutosEmUso).map(([valor, label]) => (
                                            <option key={valor} value={valor}>{label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        {error && <Alert variant="danger">{error}</Alert>}

                        {loading ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" />
                            </div>
                        ) : historico.length > 0 ? (
                            <Row>
                                <Col sm={12} lg={12}>
                                    <Table responsive className="custom-table">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Produto</th>
                                                <th>Dose</th>
                                                <th>Frequência</th>
                                                <th>Data de início</th>
                                                <th>Data de interrupção</th>
                                                <th>Status</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historico.map((registro) => (
                                                <tr key={registro.id}>
                                                    <td className="bg-id">#{registro.id}</td>
                                                    <td><div className="td-border">{registro?.dados_produto?.nome || '-'}</div></td>
                                                    <td><div className="td-border">{registro?.dose || '-'}</div></td>
                                                    <td><div className="td-border">{frequenciasProdutosEmUso[registro?.frequencia_uso] || '-'}</div></td>
                                                    <td><div className="td-border">{registro?.data_inicio_uso ? formataDataExibicao(registro.data_inicio_uso) : '-'}</div></td>
                                                    <td><div className="td-border">{registro?.data_interrupcao_uso ? formataDataExibicao(registro.data_interrupcao_uso) : '-'}</div></td>
                                                    <td><div className="td-border">{this.renderStatus(registro)}</div></td>
                                                    <td>
                                                        {podeEditar && registro?.uso_ativo ? (
                                                            <Button variant="secondary" size="sm" onClick={() => this.abrirModalEditar(registro)}>
                                                                Atualizar Medicamento
                                                            </Button>
                                                        ) : (
                                                            <span className="text-muted">Somente visualização</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        ) : (
                            <p>Nenhum medicamento em uso cadastrado até o momento</p>
                        )}
                    </Card.Body>
                </Card>

                <Modal show={showModal} onHide={this.fecharModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Produto em uso</Form.Label>
                                    {registroEditando ? (
                                        <Form.Control type="text" value={produto_nome} disabled />
                                    ) : (
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={loadProdutosDisponiveis}
                                            defaultOptions
                                            name="produto_id"
                                            onChange={this.onChangeProduto}
                                            placeholder="Buscar produto..."
                                            noOptionsMessage={() => "Nenhum produto encontrado"}
                                            value={produto_id ? { value: produto_id, label: produto_nome } : null}
                                        />
                                    )}
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Dose</Form.Label>
                                    <Form.Control type="text" name="dose" value={dose} onChange={this.onChangeCampo} />
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Frequência de uso</Form.Label>
                                    <Form.Select name="frequencia_uso" value={frequencia_uso} onChange={this.onChangeCampo}>
                                        <option value="">Selecione...</option>
                                        {Object.entries(frequenciasProdutosEmUso).map(([valor, label]) => (
                                            <option key={valor} value={valor}>{label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data de início de uso</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="data_inicio_uso"
                                        value={data_inicio_uso}
                                        onChange={this.onChangeCampo}
                                        max={this.getDataHoje()}
                                        disabled={!!registroEditando}
                                    />
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data de interrupção do uso</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="data_interrupcao_uso"
                                        value={data_interrupcao_uso}
                                        onChange={this.onChangeCampo}
                                        min={data_inicio_uso || undefined}
                                        max={this.getDataHoje()}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.fecharModal}>
                            Fechar
                        </Button>
                        <Button variant="secondary" onClick={this.salvarRegistro} disabled={loadingModal}>
                            {loadingModal ? <span className="spinner-border spinner-border-sm"></span> : (registroEditando ? 'Editar Medicamento' : 'Cadastrar Medicamento')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ProdutosEmUsoAtendimento;
